import { useMutation, useQueryClient } from "@tanstack/react-query";
import { queryKeys } from "@/lib/useQuery/queryKeys";
import { editQuestion } from ".";

export function useUpdateQuestion() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: queryKeys.question._def,
        mutationFn: editQuestion,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.question._def, exact: false });
        }
    });
}